import React from "react";
import "./App.css";
import Header from "./components/Header/Header";
import Timeline from "./components/Timeline/Timeline";
function App() {
  return (
    <div>
      <Header></Header>
      <Timeline></Timeline>
    </div>
  );
}

export default App;
